import React from "react";
import { useTranslation } from "react-i18next";
import Header from "../../../Components/Header/Header";
import { hero, service2 } from "../../../assets";

export default function Infrastruktur() {

  const { t, i18n } = useTranslation();
  return (
    <>
    <Header/>
    <div className="mx-auto bg-[#FAFAFA] pt-[140px] pb-[144px]">
       <div className="max-w-container mx-auto h-[713px]">
    <p className="text-[#405d72] text-[20px] font-semibold mb-4">{t("Xidmətlərimiz")}</p>
    <p className="text-black text-3xl font-bold mb-10">{t("İnfrastruktur")}</p>
   <img className="h-[394px] bg-black/20 rounded-lg w-full" src={service2}></img>
   <p className="text-black text-base font-normal mt-6">{t("services2")}</p>
     </div>
     
</div>
    </>
  );
}
